import { __decorate, __metadata } from "tslib";
import { ApiProperty } from '@nestjs/swagger';
import { Expose, Type } from 'class-transformer';
import { IsNotEmpty, IsString } from 'class-validator';
import { PromotionTtlUserExposeGroup } from '../interface';
export class CreatePromotionTtlUserDto {
}
__decorate([
    ApiProperty({ type: () => Date, format: 'date-time', description: 'date this offer will expire', example: 'ISODate("2018-09-04T06:45:41.716+0000")' }),
    Expose({ groups: [PromotionTtlUserExposeGroup.READ, PromotionTtlUserExposeGroup.CREATE] }),
    Type(() => Date),
    IsNotEmpty({ always: true }),
    IsString({ always: true }),
    __metadata("design:type", Date)
], CreatePromotionTtlUserDto.prototype, "expireAt", void 0);
//# sourceMappingURL=CreatePromotionTtlUserDto.js.map